import React from 'react';

class UserUpload extends React.Component {
    constructor(props) {
        super(props);

    }

    render () {
        return (
            <div className="container frame">
                <div className="row">
                    <div className="col-md-8 offset-md-2">
                        <h4>New Property</h4>
                        <form>
                            <div className="form-group">
                                <label htmlFor="inputAddress">Address</label>
                                <input type="text" className="form-control" id="inputAddress" placeholder="1234 Main St"/>
                            </div>

                            <div className="form-row">
                                <div className="form-group col-md-8">
                                <label htmlFor="inputCity">City</label>
                                <input type="text" className="form-control" id="inputCity"/>
                                </div>
                                <div className="form-group col-md-4">
                                <label htmlFor="inputZip">Postal Code</label>
                                <input type="text" className="form-control" id="inputZip"/>
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group col-md-8">
                                <label htmlFor="inputPrice">Price</label>
                                <input type="text" className="form-control" id="inputPrice"/>
                                </div>
                                <div className="form-group col-md-4">
                                <label htmlFor="inputRoom">Rooms available</label>
                                    <input type="text" className="form-control" id="inputRoom"/>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default UserUpload;